import React, { useState } from "react";
import { Box, Button, Typography, Fade } from "@mui/material";

import EmptyTemplate from "../../../assets/empty-states/empty-templates.png";

function EmptyState({
  alt = "Sem dados",
  title,
  description,
  actionLabel,
  onAction,
}) {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <Fade in={imageLoaded} timeout={500}>
      <Box
        sx={{
          width: "100%",
          minHeight: "70vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          px: 2,
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "500px",
            textAlign: "center",
          }}
        >
          <Box
            component="img"
            src={EmptyTemplate}
            alt={alt}
            onLoad={() => setImageLoaded(true)}
            sx={{
              width: "100%",
              maxWidth: "494px",
              height: "auto",
              display: "block",
              margin: "0 auto",
            }}
          />

          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1.25,
              justifyContent: "center",
              textAlign: "center",
              mt: 2,
            }}
          >
            <Typography
              fontWeight={700}
              sx={{
                fontSize: { xs: "18px", sm: "24px" },
                color: "primary.main",
              }}
            >
              {title}
            </Typography>

            <Typography
              sx={{
                fontSize: { xs: "14px", sm: "16px" },
              }}
            >
              {description}
            </Typography>

            {actionLabel && (
              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  width: "100%",
                  maxWidth: "320px",
                  marginInline: "auto",
                }}
                onClick={onAction}
              >
                {actionLabel}
              </Button>
            )}
          </Box>
        </Box>
      </Box>
    </Fade>
  );
}

export default EmptyState;
